import {LEAGUE_COLORS, getLeagueColors, getLeagueFlag, getCompetitionBrandAssets} from './competitionUtils.js';

// The creation form uses these shorter names for the same existing league mappings.
const aliases = {'Championship':'EFL Championship', 'League One':'EFL League One', 'League Two':'EFL League Two'};
export function getCompetitionHeaderBrand(comp) {
  const league = aliases[comp.league] || comp.league;
  const known = !comp.is_multi_league && Object.hasOwn(LEAGUE_COLORS, league);
  if (!known) return {
    known:false, label:comp.is_multi_league ? 'Multiple leagues' : comp.league || 'League unavailable',
    bg:null, accent:null, badgeUrl:null, flagUrl:null, fallback:'FC',
  };
  // A game format must never assign World Cup artwork to a different league.
  const assets = getCompetitionBrandAssets({...comp, type:undefined});
  return {known:true, label:comp.league, ...getLeagueColors(league), ...assets, fallback:getLeagueFlag(league)};
}
